module.exports = __webpack_public_path__ + "static/media/landing_page_video_720p.12e27a75.mp4";